<template>
  <!--案例展示-->
  <section id="cases">
    <div class="caption">
      <h1>案例展示</h1>
      <div class="caption-sub middle">
        <div class="flex"></div>
        <span>CASES</span>
        <div class="flex"></div>
      </div>
    </div>

    <div class="cases">
      <div class="imgs">
        <div class="box" ref="box1">
          <img src="../../assets/images/index/cases-1.png" />
          <div class="text">
            <h1>「故宫博物院」</h1>
            <p>
              为故宫博物院提供了核心票务系统的全网解决方案和社会化服务，通过为其定制化开发的专业线上票务系统，在国内信息化行业首创实现了全网售票、分时段限流和实名制。不断升级创新的全网售票系统，为故宫博物院全年1900余万人次接待量的有序服务提供了坚实的基础。
            </p>
          </div>
        </div>
        <div class="box" ref="box2">
          <img src="../../assets/images/index/cases-2.png" />
          <div class="text">
            <h1>「八达岭长城」</h1>
            <p>
              为八达岭长城定制开发的大数据系统，可以通过游客实名制信息、停车场泊车信息以及出入园客流精细化统计，实现景区域内精准的客流管控，从而提升景区整体的智能化管理水平，为景区下一步的精细化管理提供了数据依据。新一代的大数据系统具有维度广、数据详实、实用性高等特点，也因此受到了合作客户的高度好评。
            </p>
          </div>
        </div>
        <div class="box" ref="box3">
          <img src="../../assets/images/index/cases-3.png" />
          <div class="text">
            <h1>「秦始皇帝陵博物院」</h1>
            <p>
              通过与秦始皇帝陵博物院提供专业化的票务运维服务，对现有系统进行全方位的梳理维护与差缺堵漏，最终实现票务系统稳健快速的运行，保证信息安全，从而实现客户的最大价值。
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import play from "./play";

export default {
  mounted() {
    play([this.$refs.box1, this.$refs.box2, this.$refs.box3], "anm-fadeIn");
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/common.scss";

section#cases {
  display: flex;
  flex-direction: column;
  align-items: center;

  > .cases {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-bottom: 40px;

    > .imgs {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: $SIZE_PAGE_WIDTH;

      > .box {
        width: 100%;
        flex-grow: 1;
        margin-right: 5px;
        background-size: 100% 100%;
        position: relative;

        > img {
          width: 100%;
          height: 50%;
        }

        > .text {
          overflow: hidden;
        }
      }

      > .box {
        color: #ffffff;

        > .text {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 0;
          bottom: 0;
          width: 100%;
          line-height: 30px;
          padding: 2vw;
          background: #006699;
          color: #ffffff;
          opacity: 0.8;
          visibility: hidden;

          > h1 {
            line-height: 5vw;
            font-size: 1.5vw;
            text-align: center;
          }

          > p {
            line-height: 2vw;
            font-size: 0.9vw;
            text-align: justify;
            letter-spacing: 1px;
          }
        }
      }

      > .box:hover {
        > .text {
          visibility: visible;
        }
      }
    }
  }

  .anm-fadeIn {
    animation: fadeIn 3s;
    //   animation-fill-mode: forwards;
  }
}
</style>